import requestAction from '../../utils/requestAction'

export const fetchClients = (params: string = "") =>
  requestAction('CLIENT_LIST', params)(`clients`, 'GET')

export const fetchAllClients = () =>
  fetchClients('?all=true')